var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"BaseValidationError txt txt--12px mt-4 txt--color-07",class:{'is-active': _vm.$attrs.error || !!_vm.error, 'is-small': _vm.small}},[_c('span',{staticClass:"message"},[_vm._v(_vm._s(_vm.$attrs.error || _vm.error))])])}
var staticRenderFns = []

export { render, staticRenderFns }